import { useContext } from 'react';

import { homeownerAppContext } from 'src/modules/homeownerApp/providers/HomeownerAppProvider';
import type { HomeownerAppContextProps } from 'src/modules/homeownerApp/providers/HomeownerAppProvider';

const useHomeownerAppContext = (): HomeownerAppContextProps => {
  const context = useContext(homeownerAppContext);
  return context;
};

export { useHomeownerAppContext };
